var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinbattingFullLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 103,
    viewBox: "0 0 344 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.518 37.2667C315.917 37.3274 313.626 35.0205 313.688 32.4707C313.626 29.9209 315.917 27.614 318.518 27.614C321.118 27.5533 323.347 29.8602 323.347 32.4707C323.347 35.0205 321.118 37.3274 318.518 37.2667ZM318.518 28.7067C316.474 28.7067 314.865 30.3459 314.865 32.41C314.865 34.4741 316.474 36.174 318.518 36.174C320.561 36.174 322.17 34.5348 322.17 32.41C322.17 30.3459 320.561 28.7067 318.518 28.7067ZM320.994 34.8384H319.632L318.456 33.3206H317.836V34.8384H316.598V30.0423H318.579C319.632 30.0423 320.437 30.7101 320.437 31.6815C320.437 32.2886 320.127 32.7742 319.632 33.0171L320.994 34.8384ZM317.836 32.2886H318.579C318.951 32.2886 319.199 32.0457 319.199 31.7422C319.199 31.3779 318.951 31.1351 318.579 31.1351H317.836V32.2886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6566 17H32.762C26.266 17 21 22.1463 21 28.4946V66.5054C21 72.8537 26.266 78 32.762 78H71.6566C78.1526 78 83.4186 72.8537 83.4186 66.5054V28.4946C83.4186 22.1463 78.1526 17 71.6566 17Z",
    fill: "url(#paint0_linear_13_88)",
    stroke: "url(#paint1_linear_13_88)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.18 43.8395C71.4479 38.668 70.4026 34.0455 71.9077 28.4114C71.9644 28.1965 71.9078 27.9847 71.7555 27.8205C71.6002 27.6564 71.3881 27.5878 71.1611 27.6265C67.4969 28.2473 63.0354 30.1959 60.6613 32.9593C60.3418 33.2428 59.9086 33.3472 59.4965 33.2427C58.1079 32.8996 56.7851 32.6728 55.4352 32.5385C54.3811 32.3923 53.3029 32.3117 52.2099 32.3117C51.1169 32.3117 50.0389 32.3923 48.9848 32.5385C47.632 32.6728 46.312 32.8996 44.9233 33.2427C44.5112 33.3472 44.0782 33.2428 43.7587 32.9593C41.3846 30.1989 36.9081 28.2473 33.2439 27.6265C33.0169 27.5878 32.8048 27.6594 32.6495 27.8205C32.4942 27.9847 32.4375 28.1935 32.4973 28.4114C34.0024 34.0485 32.9691 38.6709 31.24 43.8395C30.0186 47.4892 28.0028 50.3212 28.0954 55.7344C28.0954 55.8657 28.176 55.9732 28.2985 56.0239C28.4239 56.0747 28.5583 56.0478 28.6538 55.9582C29.8962 54.7765 30.6427 54.499 31.2698 54.8273C32.2732 55.3525 30.9623 58.0442 33.2618 60.0645C33.3603 60.151 33.4976 60.1719 33.6201 60.1182C33.7425 60.0615 33.8142 59.9481 33.8112 59.8168C33.7634 58.5067 34.5608 57.7756 35.0625 57.6234C35.603 57.4563 36.3198 57.6085 37.138 58.4411C38.9 60.2286 40.7066 62.043 42.8657 63.5231C44.3977 64.5735 45.9924 65.4629 47.6259 66.197C49.1638 66.943 50.687 67.3279 52.207 67.3369C53.73 67.3279 55.25 66.943 56.788 66.197C58.4215 65.4629 60.0162 64.5735 61.5482 63.5231C63.7073 62.043 65.5111 60.2286 67.276 58.4411C68.0942 57.6085 68.8109 57.4623 69.3514 57.6234C69.8531 57.7786 70.558 58.7843 70.5102 60.0943C70.5042 60.2256 70.5788 60.339 70.7012 60.3957C70.8237 60.4494 70.9611 60.4315 71.0596 60.342C73.3591 58.3217 72.1406 55.3525 73.141 54.8273C73.7681 54.496 74.5147 54.7765 75.76 55.9582C75.8556 56.0508 75.9901 56.0747 76.1155 56.0239C76.241 55.9732 76.3186 55.8657 76.3216 55.7344C76.4171 50.3241 74.4013 47.4892 73.1769 43.8395H73.18ZM46.6345 55.0003C45.1742 54.9765 43.012 54.6661 41.4532 52.986C40.7604 52.24 39.5868 50.5688 39.7511 47.3907C39.757 47.2504 39.9451 47.1758 40.0706 47.2654C40.4916 47.5578 41.3039 48.1188 42.1162 48.665C43.0688 49.3065 51.6157 55.057 46.6345 55.0003ZM63.337 52.986C61.7782 54.6661 59.6161 54.9765 58.1557 55.0003C53.1746 55.057 61.7214 49.3065 62.674 48.665C63.4863 48.1188 64.2956 47.5578 64.7197 47.2654C64.8481 47.1758 65.0332 47.2504 65.0392 47.3907C65.2034 50.5688 64.0269 52.24 63.337 52.986Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.971 55.7146C112.729 55.7495 110.576 54.8553 109.016 53.2446C105.731 49.9533 105.734 44.6232 109.028 41.335C110.604 39.7623 112.741 38.8777 114.971 38.8745H122.999C123.23 38.8745 123.43 38.716 123.487 38.494L126.046 28.2301C126.122 27.9289 125.894 27.6404 125.583 27.6404H114.425C107.307 27.6404 99.2656 33.0276 96.7448 39.6862C91.4369 53.7138 101.656 66.9487 114.967 66.9487H125.688C125.967 66.9487 126.192 66.7236 126.192 66.4446V56.2156C126.192 55.9366 125.967 55.7114 125.688 55.7114H114.967L114.971 55.7146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.743 55.6871L142.431 55.7283C141.942 55.7283 141.778 55.0751 142.209 54.8436L144.061 54.0224C144.216 53.94 144.314 53.7782 144.314 53.6007L144.321 28.1392C144.321 27.876 144.108 27.6636 143.845 27.6636H133.562C133.299 27.6636 133.086 27.876 133.086 28.1392V66.4424C133.086 66.7056 133.299 66.918 133.562 66.918H155.171C155.39 66.918 155.58 66.769 155.634 66.5566L158.205 56.2737C158.282 55.9724 158.053 55.6807 157.743 55.6839V55.6871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.155 27.6545L184.837 27.6165C184.574 27.6165 184.358 27.8289 184.358 28.0921V47.3103C184.358 52.9257 182.487 55.7287 178.746 55.7224C175.004 55.7129 173.153 52.9099 173.184 47.3103V28.1301C173.184 27.8669 172.972 27.6545 172.709 27.6545H162.426C162.163 27.6545 161.95 27.8669 161.95 28.1301V47.3103C161.95 60.412 167.566 66.966 178.797 66.966C190.028 66.966 195.637 60.4152 195.63 47.3103V28.1301C195.63 27.8669 195.418 27.6545 195.158 27.6545H195.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.127 27.6226L203.14 27.7082C202.877 27.7082 202.665 27.9206 202.665 28.1838V38.4699C202.665 38.733 202.877 38.9455 203.14 38.9455H213.081C213.604 38.9455 213.775 39.6431 213.315 39.8872L211.429 40.5626C211.273 40.645 211.175 40.8068 211.175 40.9843L211.093 66.4902C211.093 66.7534 211.305 66.9658 211.568 66.9658H221.851C222.114 66.9658 222.327 66.7534 222.327 66.4902V39.3323C222.327 39.0692 222.539 38.8567 222.802 38.8567H227.565C227.784 38.8567 227.974 38.7077 228.028 38.4952L230.59 28.2124C230.666 27.9111 230.438 27.6194 230.127 27.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.573 55.7144C249.312 55.7683 247.131 54.8741 245.558 53.2443C242.273 49.953 242.277 44.6197 245.571 41.3348C247.147 39.7621 249.284 38.8774 251.513 38.8743H259.614C259.833 38.8743 260.023 38.7252 260.077 38.5128L262.649 28.2299C262.725 27.9287 262.497 27.6401 262.186 27.6401H250.679C244.189 27.6401 236.563 32.4217 233.906 38.3416C227.393 52.8575 237.837 66.9485 251.573 66.9485H262.319C262.582 66.9485 262.795 66.736 262.795 66.4729V56.19C262.795 55.9268 262.582 55.7144 262.319 55.7144H251.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.934 27.696H270.1C269.836 27.696 269.624 27.9084 269.624 28.1716V66.4748C269.624 66.738 269.836 66.9504 270.1 66.9504H280.367C280.63 66.9504 280.842 66.738 280.842 66.4748V53.3953C280.842 53.1321 281.055 52.9197 281.318 52.9197H293.805L296.902 52.8626C297.267 52.8563 297.394 53.3446 297.07 53.5158L295.158 54.3877C295.003 54.4702 294.905 54.6319 294.905 54.8095L294.883 66.478C294.883 66.7412 295.095 66.9536 295.358 66.9536H305.641C305.904 66.9536 306.117 66.7412 306.117 66.478V28.1209C306.117 27.8577 305.901 27.6453 305.638 27.6453L295.355 27.6992C295.092 27.6992 294.883 27.9116 294.883 28.1748V41.2575C294.883 41.5207 294.67 41.7331 294.407 41.7331H281.86C281.324 41.6443 280.909 41.2194 280.842 40.6836L280.937 27.7055C280.937 27.7055 280.842 38.9809 280.842 38.9713",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_88",
    x: 0.75,
    y: 0.75,
    width: 342.597,
    height: 101.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_88"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_88",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_88",
    x: 23.0923,
    y: 25.616,
    width: 58.2324,
    height: 49.7209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_88"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_88",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_88",
    x1: 24.9313,
    y1: 62.2452,
    x2: 84.294,
    y2: 28.6462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA0DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_88",
    x1: 20.6806,
    y1: 47.4984,
    x2: 83.738,
    y2: 47.4984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99D0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A9DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbattingFullLogo);
export default __webpack_public_path__ + "static/media/coinbatting-full-logo.0da2b651b9259f9237952e7a7acb08fe.svg";
export { ForwardRef as ReactComponent };